// PercentileChart.js
import React from "react";
import { motion } from "framer-motion";

const PercentileChart = ({
  lowerPercentile,
  averagePercentile,
  upperPercentile,
  addOn,
  min = 0,
  max = 100,
  height = "1rem",
  compact = false,
}) => {
  // Full data range for visual bar (from p10 to p90)
  const visualMin = lowerPercentile;
  const visualMax = upperPercentile;
  const range = visualMax - visualMin;

  const sigma = range / 2.5632;

  const lowerBound = averagePercentile - sigma;
  const upperBound = averagePercentile + sigma;

  const clampedLower = Math.max(visualMin, lowerBound);
  const clampedUpper = Math.min(visualMax, upperBound);

  const left = ((clampedLower - visualMin) / range) * 100;
  const width = ((clampedUpper - clampedLower) / range) * 100;
  const medianPos = ((averagePercentile - visualMin) / range) * 100;



  return (
    <motion.div className="relative w-full mt-1" style={{ height }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Base bar */}
      <div className="absolute inset-0 bg-secondary/50 rounded-full" />

      {/* 68% confidence area */}
      <motion.div
        className="absolute h-full bg-red-500/40 rounded-full"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        style={{
          left: `${left}%`,
          width: `${width}%`,
        }}
      />


      {/* Median marker */}
      <motion.div
        className="absolute w-1 bg-red-500"
        initial={{ height: 0 }}
        animate={{ height: "100%" }}
        transition={{ delay: 0.3 }}
        style={{
          left: `${medianPos}%`,
          transform: "translateX(-50%)",
        }}
      />
      {/* Median value label below the red line */}
      <motion.div
        className={`absolute ${compact ? "text-xs" : "text-sm sm:text-base"
          } text-white/70 font-semibold`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        style={{
          top: "100%", // place directly below bar
          left: `${medianPos}%`,
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",   // prevents wrapping/clipping
          paddingTop: "4px",
          textAlign: "center",
        }}
      >
        {Math.round(averagePercentile)}{addOn}
      </motion.div>

      {/* Labels below the bar */}
      <div
        className={`absolute w-full flex justify-between ${compact ? "text-xs" : "text-sm sm:text-base"
          } text-white/70 font-medium px-1`}
        style={{
          top: "100%",
          paddingTop: "4px",
        }}
      >
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          {Math.max(1, Math.round(lowerPercentile))}{addOn}
        </motion.span>

        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          {Math.round(upperPercentile)}{addOn}
        </motion.span>
      </div>


    </motion.div>
  );
};

export default PercentileChart;
